import isEqual from 'lodash-es/isEqual';
import { useEffect, useState } from 'react';
export default class Store {
    state;
    useDeepCompare;
    constructor(defaultValues, useDeepCompare = false) {
        this.state = defaultValues;
        this.useDeepCompare = useDeepCompare;
    }
    callbacks = new Map();
    on(key, callback) {
        const existingCallbacks = this.callbacks.get(key);
        if (existingCallbacks) {
            existingCallbacks.add(callback);
        }
        else {
            this.callbacks.set(key, new Set([callback]));
        }
    }
    off(key, callback) {
        const existingCallbacks = this.callbacks.get(key);
        if (existingCallbacks) {
            existingCallbacks.delete(callback);
        }
    }
    setState(key, newValue) {
        if (this.state[key] === newValue) {
            return;
        }
        else if (this.useDeepCompare && isEqual(this.state[key], newValue)) {
            return;
        }
        this.state[key] = newValue;
        const existingCallbacks = this.callbacks.get(key);
        if (existingCallbacks) {
            existingCallbacks.forEach((callback) => callback(newValue));
        }
    }
    getState(key) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.state[key];
    }
    subscribe(key, callback) {
        this.on(key, callback);
        return () => this.off(key, callback);
    }
}
export function useStoreUpdate(store, key) {
    const updateState = (newValue) => {
        store.setState(key, newValue);
    };
    return updateState;
}
export function useStoreValue(store, key) {
    const [state, setState] = useState(store.getState(key));
    useEffect(() => {
        const unsubscribe = store.subscribe(key, setState);
        return () => unsubscribe();
    }, [store, key]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return state;
}
export function useStoreState(store, key) {
    const state = useStoreValue(store, key);
    const updateState = useStoreUpdate(store, key);
    return [state, updateState];
}
//# sourceMappingURL=Store.js.map